module.exports = __webpack_public_path__ + "public/StoreIcon/pswd.svg?17dcad47";